import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUnusedFinanceCodes, getUsedFinanceCodes } from "../../../actions/makeAWish";
import DualListBox from "../../listbox/DualListBox";
import defaultLang from "../../listbox/lang/default";
import Loading from "../../Loading";
import { IAppState } from "../../../types/stores";

type Props = {
    id: string;
    onChange: (newCodes: Array<string>, hasError?: boolean) => void;
};

const FinanceCodes: React.FC<Props> = ({ id, onChange }: Props) => {
    const dispatch = useDispatch();

    const [usedCodes, setUsedCodes] = useState<Array<string>>([]);
    const [options, setOptions] = useState<Array<{ label: string; value: string; tooltip: string }>>([]);

    const unusedFinanceCodes = useSelector((state: IAppState) => state.makeAWish.unusedFinanceCodes || []);
    const usedFinanceCodes = useSelector((state: IAppState) => state.makeAWish.usedFinanceCodes || []);
    const isCodesLoading = useSelector((state: IAppState) => state.makeAWish.isCodesLoading);

    useEffect(() => {
        // get the columns of finance codes
        dispatch(getUnusedFinanceCodes(id)); // left
        dispatch(getUsedFinanceCodes(id)); // right
    }, [id, dispatch]);

    useEffect(() => {
        //create the full list of options
        const options = unusedFinanceCodes.map(x => ({
            label: x.FullCode,
            value: x.Code,
            tooltip: x.FullCode,
        }));

        usedFinanceCodes.forEach(x =>
            options.push({
                label: x.FullCode,
                value: x.Code,
                tooltip: x.FullCode,
            })
        );

        setUsedCodes(usedFinanceCodes.map(x => x.Code));
        setOptions(options);
    }, [usedFinanceCodes, unusedFinanceCodes]);

    const onListChange = newUsedCodes => {
        setUsedCodes(newUsedCodes);
        onChange(newUsedCodes, false);
    };

    let lang = defaultLang;
    lang.availableHeader = "Available";
    lang.selectedHeader = "Selected";

    return (
        <div className="row m-t">
            <div className="col-sm-16 text-nowrap" style={{ height: "300px" }}>
                {isCodesLoading ? (
                    <Loading />
                ) : options.length > 0 ? (
                    <DualListBox
                        options={options}
                        canFilter
                        selected={usedCodes}
                        onChange={e => onListChange(e)}
                        showHeaderLabels={true}
                        lang={lang}
                    />
                ) : (
                    <p>{"No Finance Codes to Display."}</p>
                )}
            </div>
        </div>
    );
};

export default FinanceCodes;
